export { default } from './InputOfDimension';
